import { sk as reactSk } from '@ews/react-translations';

const sk = {
    ...reactSk
};
export default sk;
